<app-page-content>
  <ng-container title>{{ "Users.AddNewUser" | translate }}</ng-container>
    <section class="madar--v2" content>
      <mat-card>
        <mat-card-content>
          <app-user-form
            [userType]="userType"
            [id]="id"
            (close)="handleCloseEvent()"></app-user-form>
        </mat-card-content>
      </mat-card>
    </section>
</app-page-content>
